import {CHART_COLORS} from './colors';
import _ from 'underscore';
const DATESTRINGS = ["Jan 1","Jan 2","Jan 3","Jan 4","Jan 5","Jan 6","Jan 7","Jan 8","Jan 9","Jan 10","Jan 11","Jan 12","Jan 13","Jan 14","Jan 15","Jan 16","Jan 17","Jan 18","Jan 19","Jan 20","Jan 21","Jan 22","Jan 23","Jan 24","Jan 25","Jan 26","Jan 27","Jan 28","Jan 29","Jan 30","Jan 31","Feb 1","Feb 2","Feb 3","Feb 4","Feb 5","Feb 6","Feb 7","Feb 8","Feb 9","Feb 10","Feb 11","Feb 12","Feb 13","Feb 14","Feb 15","Feb 16","Feb 17","Feb 18","Feb 19","Feb 20","Feb 21","Feb 22","Feb 23","Feb 24","Feb 25","Feb 26","Feb 27","Feb 28","Mar 1","Mar 2","Mar 3","Mar 4","Mar 5","Mar 6","Mar 7","Mar 8","Mar 9","Mar 10","Mar 11","Mar 12","Mar 13","Mar 14","Mar 15","Mar 16","Mar 17","Mar 18","Mar 19","Mar 20","Mar 21","Mar 22","Mar 23","Mar 24","Mar 25","Mar 26","Mar 27","Mar 28","Mar 29","Mar 30","Mar 31","Apr 1","Apr 2","Apr 3","Apr 4","Apr 5","Apr 6","Apr 7","Apr 8","Apr 9","Apr 10","Apr 11","Apr 12","Apr 13","Apr 14","Apr 15","Apr 16","Apr 17","Apr 18","Apr 19","Apr 20","Apr 21","Apr 22","Apr 23","Apr 24","Apr 25","Apr 26","Apr 27","Apr 28","Apr 29","Apr 30","May 1","May 2","May 3","May 4","May 5","May 6","May 7","May 8","May 9","May 10","May 11","May 12","May 13","May 14","May 15","May 16","May 17","May 18","May 19","May 20","May 21","May 22","May 23","May 24","May 25","May 26","May 27","May 28","May 29","May 30","May 31","Jun 1","Jun 2","Jun 3","Jun 4","Jun 5","Jun 6","Jun 7","Jun 8","Jun 9","Jun 10","Jun 11","Jun 12","Jun 13","Jun 14","Jun 15","Jun 16","Jun 17","Jun 18","Jun 19","Jun 20","Jun 21","Jun 22","Jun 23","Jun 24","Jun 25","Jun 26","Jun 27","Jun 28","Jun 29","Jun 30","Jul 1","Jul 2","Jul 3","Jul 4","Jul 5","Jul 6","Jul 7","Jul 8","Jul 9","Jul 10","Jul 11","Jul 12","Jul 13","Jul 14","Jul 15","Jul 16","Jul 17","Jul 18","Jul 19","Jul 20","Jul 21","Jul 22","Jul 23","Jul 24","Jul 25","Jul 26","Jul 27","Jul 28","Jul 29","Jul 30","Jul 31","Aug 1","Aug 2","Aug 3","Aug 4","Aug 5","Aug 6","Aug 7","Aug 8","Aug 9","Aug 10","Aug 11","Aug 12","Aug 13","Aug 14","Aug 15","Aug 16","Aug 17","Aug 18","Aug 19","Aug 20","Aug 21","Aug 22","Aug 23","Aug 24","Aug 25","Aug 26","Aug 27","Aug 28","Aug 29","Aug 30","Aug 31","Sep 1","Sep 2","Sep 3","Sep 4","Sep 5","Sep 6","Sep 7","Sep 8","Sep 9","Sep 10","Sep 11","Sep 12","Sep 13","Sep 14","Sep 15","Sep 16","Sep 17","Sep 18","Sep 19","Sep 20","Sep 21","Sep 22","Sep 23","Sep 24","Sep 25","Sep 26","Sep 27","Sep 28","Sep 29","Sep 30","Oct 1","Oct 2","Oct 3","Oct 4","Oct 5","Oct 6","Oct 7","Oct 8","Oct 9","Oct 10","Oct 11","Oct 12","Oct 13","Oct 14","Oct 15","Oct 16","Oct 17","Oct 18","Oct 19","Oct 20","Oct 21","Oct 22","Oct 23","Oct 24","Oct 25","Oct 26","Oct 27","Oct 28","Oct 29","Oct 30","Oct 31","Nov 1","Nov 2","Nov 3","Nov 4","Nov 5","Nov 6","Nov 7","Nov 8","Nov 9","Nov 10","Nov 11","Nov 12","Nov 13","Nov 14","Nov 15","Nov 16","Nov 17","Nov 18","Nov 19","Nov 20","Nov 21","Nov 22","Nov 23","Nov 24","Nov 25","Nov 26","Nov 27","Nov 28","Nov 29","Nov 30","Dec 1","Dec 2","Dec 3","Dec 4","Dec 5","Dec 6","Dec 7","Dec 8","Dec 9","Dec 10","Dec 11","Dec 12","Dec 13","Dec 14","Dec 15","Dec 16","Dec 17","Dec 18","Dec 19","Dec 20","Dec 21","Dec 22","Dec 23","Dec 24","Dec 25","Dec 26","Dec 27","Dec 28","Dec 29","Dec 30","Dec 31"];
const HOVER_LABEL = {
  namelength: -1,
  bgcolor: '#333333',
  bordercolor: '#d3d3d3',
  font: {color: '#FFFFFF'}
};

export const findMissingYears = (currentYears, thisYear) => {
  let range = 2; // this.is how many years we want to fetch on either side of the array.
  let start = thisYear - range;
  let end = thisYear + range;
  let years = [];
  for(let x = start; x <= end; x++){
    if(!currentYears.includes(x)){years.push(x)}
  }
  return years.join('&');
}

// builds the stats for multiple alts
export const buildMultiStatsPlot = (data, index, statsFilter) => {
  const { average, fiftieth, max, min, ninetieth, tenth } = statsFilter;
  const name = data[index].short_name || data[index].location; // name is either an alternative or a location
  const color = data[index].color;
  let maximumTrace = {
    lineType: 'stat',
    key: `maximum-${index}`,
    x: [],
    y: [],
    visible: true,
    name: 'Maximum ' + (name || 'No Alternative Name'),
    short_name: name,
    line: {
      width: 2,
      dash: 'dot',
      color: color || CHART_COLORS[index]
    },
  };

  let ninetiethTrace = {
    lineType: 'stat',
    key: `ninetieth-${index}`,
    x: [],
    y: [],
    visible: true,
    name: '90th % ' + (name || 'No Alternative Name'),
    short_name: name,
    line: {
      width: 2,
      dash: 'dashdot',
      color: color || CHART_COLORS[index]
    },
  };

  let averageTrace = {
    lineType: 'line',
    key: `average-${index}`,
    x: [],
    y: [],
    visible: true,
    name: 'Average ' + (name || 'No Alternative Name'),
    short_name: name,
    type: 'scatter',
    line: {
      dash: 'dash',
      color: color || CHART_COLORS[index],
      width: 2
    },
  };

  let fiftiethTrace = {
    lineType: 'stat',
    key: `fiftieth-${index}`,
    x: [],
    y: [],
    visible: true,
    name: '50th % ' + (name || 'No Alternative Name'),
    short_name: name,
    type: 'scatter',
    line: {
      dash: 'longdash',
      color: color || CHART_COLORS[index],
      width: 2
    },

  };
  
  let tenthTrace = {
    lineType: 'stat',
    key: `tenth-${index}`,
    x: [],
    y: [],
    visible: true,
    name: '10th % ' + (name || 'No Alternative Name'),
    short_name: name,
    type: 'scatter',
    line: {
      width: 2,
      dash: 'dashdot',
      color: color || CHART_COLORS[index]
    },
  };

  let minimumTrace = {
    lineType: 'stat',
    key: `minimum-${index}`,
    x: [],
    y: [],
    visible: true,
    name: 'Minimum ' + (name || 'No Alternative Name'),
    short_name: name,
    type: 'scatter',
    line: {
      width: 2,
      dash: 'dot',
      color: color || CHART_COLORS[index]
    },
  };

  let valueTrace = {
    lineType: 'line',
    key: `value-${index}`,
    x: [],
    y: [],
    visible: true,
    name: 'Selected Alternative ' + (name || 'No Alternative Name'),
    short_name: name,
    line: {
      width: 3,
      dash: 'solid',
      color: color || CHART_COLORS[index]
    },
  };

  data.map(item => {
    const {date, value, minimum, maximum, average, fiftieth, ninetieth, tenth } = item;
    if(tenth){
      tenthTrace.y.push(tenth);
      tenthTrace.x.push(date);
    };
    if(ninetieth){
      ninetiethTrace.y.push(ninetieth);
      ninetiethTrace.x.push(date);
    };

    if(average){
      averageTrace.y.push(average);
      averageTrace.x.push(date);
    };

    if(fiftieth){
      fiftiethTrace.y.push(fiftieth);
      fiftiethTrace.x.push(date);
    };

    if(min){
      minimumTrace.y.push(minimum);
      minimumTrace.x.push(date);
    };

    if(max){
      maximumTrace.y.push(maximum);
      maximumTrace.x.push(date);
    };

    valueTrace.y.push(value);
    valueTrace.x.push(date);
    valueTrace.name = item.short_name || 'Selected'
    return item;
  });

  let dataToCharts = [
    valueTrace
  ];

  if(tenth){ dataToCharts.push(tenthTrace) };
  if(ninetieth){ dataToCharts.push(ninetiethTrace) };
  if(average){ dataToCharts.push(averageTrace) };
  if(fiftieth){ dataToCharts.push(fiftiethTrace) };
  if(min){ dataToCharts.push(minimumTrace) };
  if(max){ dataToCharts.push(maximumTrace) };

  return dataToCharts
};

export const buildTrace = (data, index) => {
  const name = data[0].short_name || data[0].location || 'No Name';
  const color = data[0].color || CHART_COLORS[index];
  const plotData = {
    lineType: 'single',
    key: `multi-alt-${name}-plot-${index}`,
    x: data.map(({date}) => (date)),
    y: data.map(({value}) => (value)),
    visible: true,
    name,
    short_name: name,
    hoverinfo: 'y+x+name',
    hoverlabel: {
      ...HOVER_LABEL,
      bordercolor: color || null
    },
    line: {
      width: 2,
      dash: 'solid',
      color: color || null,
    }
  };
  return plotData
};

export const arrayToObject = (array) => {
  return array.reduce((obj, item) => {
    var key = Object.keys(item)[0];
    obj[key] = item[key]
    return obj
  }, {})
};

export const buildStatYear = (data, stat, pickYear, selectedAlts) => {
  /* 
    the data is a bulk set of data grouped by year { 1931: [], 1932: [] .... };
    stat is a stirng for the selected stat to show 'minimum' or 'maximum' etc.
    pickYear a number between 1932 - 2012
    pickYear enabled is a boolean
    selected alts as a object with the alternatives to be show { alt1: true, alt2: false, alt3: true ... }
    datum is a value to adjust the chart values eg. 500 OR is null if it doesnt exist
    useDatum is boolean to decide if the daum should be applied;
  */

  let lines = [];

  // if data[pickYear] is underfined its because the data for that year has not loaded yet. use 2012 as a fall back.
  const groupedAlts = _.groupBy(data[pickYear] || data[2012], 'short_name');
  Object.keys(groupedAlts).forEach((alt, index) => {
    const color = groupedAlts[alt] && groupedAlts[alt][0] && groupedAlts[alt][0].color ? groupedAlts[alt][0].color : CHART_COLORS[index];
      let maximumTrace = {
        lineType: 'stat',
        key: `${alt}-maximum-${index}`,
        x: [],
        y: [],
        visible: !selectedAlts[alt] && (stat === 'maximum' )? 'legendonly' : stat === 'maximum',
        name: alt + ' Maximum',
        short_name: alt,
        line: {
          width: 2,
          dash: 'dot',
          color
        },
        hoverinfo: 'y+x+name',
        hoverlabel: {
          ...HOVER_LABEL,
          bordercolor: color
        }
      };
    
      let ninetiethTrace = {
        lineType: 'stat',
        key: `${alt}-ninetieth-${index}`,
        x: [],
        y: [],
        visible: !selectedAlts[alt] && (stat === 'ninetieth') ? 'legendonly' : stat === 'ninetieth',
        name: alt + ' 90th %',
        short_name: alt,
        line: {
          width: 2,
          dash: 'dash',
          color: color
        },
        hoverinfo: 'y+x+name',
        hoverlabel: {
          ...HOVER_LABEL,
          bordercolor: color
        }
      };
    
      let averageTrace = {
        lineType: 'stat',
        key: `average-${index}`,
        x: [],
        y: [],
        visible: !selectedAlts[alt] && (stat === 'average') ? 'legendonly' : stat === 'average',
        name: alt + ' Average',
        short_name: alt,
        line: {
          color: color,
          dash: 'solid',
          width: 2
        },
        hoverinfo: 'y+x+name',
        hoverlabel: {
          ...HOVER_LABEL,
          bordercolor: color
        }
      };
    
      let fiftiethTrace = {
        lineType: 'stat',
        key: `${alt}-fiftieth-${index}`,
        x: [],
        y: [],
        visible: !selectedAlts[alt] && (stat === 'fiftieth') ? 'legendonly' : stat === 'fiftieth',
        name: alt + ' 50th %',
        short_name: alt,
        line: {
          color: color,
          dash: 'solid',
          width: 2
        },
        hoverinfo: 'y+x+name',
        hoverlabel: {
          ...HOVER_LABEL,
          bordercolor: color
        }
      };
      
      let tenthTrace = {
        lineType: 'stat',
        key: `${alt}-tenth-${index}`,
        x: [],
        y: [],
        visible: !selectedAlts[alt] && (stat === 'tenth') ? 'legendonly' : stat === 'tenth',
        name: alt + ' 10th %',
        short_name: alt,
        line: {
          width: 2,
          dash: 'dash',
          color: color
        },
        hoverinfo: 'y+x+name',
        hoverlabel: {
          ...HOVER_LABEL,
          bordercolor: color
        }
      };
    
      let minimumTrace = {
        lineType: 'stat',
        key: `${alt}-minimum-${index}`,
        x: [],
        y: [],
        visible: !selectedAlts[alt] && (stat === 'minimum') ? 'legendonly' : stat === 'minimum',
        name: alt + ' Minimum',
        short_name: alt,
        line: {
          width: 2,
          dash: 'dot',
          color: color
        },
        hoverinfo: 'y+x+name',
        hoverlabel: {
          ...HOVER_LABEL,
          bordercolor: color
        }
      };
    
      let valueTrace = {
        lineType: 'value',
        key: `${alt}-value-${index}`,
        x: [],
        y: [],
        visible: !selectedAlts[alt] && (stat === 'value') ? 'legendonly' : stat === 'value',
        name: alt,
        short_name: alt,
        line: {
          width: 2,
          dash: 'solid',
          color: color
        },
        hoverinfo: 'y+x+name',
        hoverlabel: {
          ...HOVER_LABEL,
          bordercolor: color
        }
      };
  
      groupedAlts[alt].forEach(item => {
        let { date, value, minimum, maximum, average, fiftieth, ninetieth, tenth } = item;
        tenthTrace.y.push(tenth);
        tenthTrace.x.push(date);
  
        ninetiethTrace.y.push(ninetieth);
        ninetiethTrace.x.push(date);
  
        averageTrace.y.push(average);
        averageTrace.x.push(date);
  
        fiftiethTrace.y.push(fiftieth);
        fiftiethTrace.x.push(date);
  
        minimumTrace.y.push(minimum);
        minimumTrace.x.push(date);
  
        maximumTrace.y.push(maximum);
        maximumTrace.x.push(date);
  
        valueTrace.y.push(value);
        valueTrace.x.push(date);
      });
      lines.push(maximumTrace, ninetiethTrace, averageTrace, fiftiethTrace, tenthTrace, minimumTrace, valueTrace );
  });
  return lines; 
};

// builds the stats lines for a plot
export const buildStatsPlot = (data, year, index) => {
  let annualData = data[year || 2012];

  if(!annualData) return [];

  let maximumTrace = {
    lineType: 'stat',
    key: `min-max`,
    x: [],
    y: [],
    visible: true,
    name: 'Maximum',
    type: 'scatter',
    fill: 'tonexty',
    legendgroup: 'minmax',
    line: {
      width: 2,
      dash: 'solid',
      color: '#d3d3d3'
    },
    hoverlabel: {
      ...HOVER_LABEL,
      bordercolor: '#d3d3d3'
    },
    hoverinfo: 'y+x+name'
  };

  let minimumTrace = {
    lineType: 'stat',
    key: `min-max`,
    x: [],
    y: [],
    visible: true,
    name: 'Minimum',
    type: 'scatter',
    legendgroup: 'minmax',
    line: {
      width: 2,
      dash: 'solid',
      color: '#d3d3d3'
    },
    hoverlabel: {
      ...HOVER_LABEL,
      bordercolor: '#d3d3d3'
    },
    hoverinfo: 'y+x+name'
  };

  let ninetiethTrace = {
    lineType: 'stat',
    key: `nine-ten`,
    x: [],
    y: [],
    visible: true,
    name: 'Ninetieth percentile',
    type: 'scatter',
    fill: 'tonexty',
    legendgroup: 'nineten',
    line: {
      width: 2,
      dash: 'solid',
      color: '#999999'
    },
    hoverlabel: {
      ...HOVER_LABEL,
      bordercolor: '#999999'
    },
    hoverinfo: 'y+x+name'
  };

  let tenthTrace = {
    lineType: 'stat',
    key: `nine-ten`,
    x: [],
    y: [],
    visible: true,
    name: 'Tenth percentile',
    type: 'scatter',
    legendgroup: 'nineten',
    line: {
      width: 2,
      dash: 'solid',
      color: '#999999'
    },
    hoverlabel: {
      ...HOVER_LABEL,
      bordercolor: '#999999'
    },
    hoverinfo: 'y+x+name'
  };

  let averageTrace = {
    lineType: 'line',
    key: `average-${index}`,
    x: [],
    y: [],
    visible: true,
    name: 'Average',
    type: 'scatter',
    line: {
      color: '#66FF00',
      dash: 'solid',
      width: 2
    },
    hoverlabel: {
      ...HOVER_LABEL,
      bordercolor: '#66FF00'
    },
    hoverinfo: 'y+x+name'
  };

  let fiftiethTrace = {
    lineType: 'stat',
    key: `fiftieth-${index}`,
    x: [],
    y: [],
    visible: true,
    name: 'Fiftieth percentile',
    type: 'scatter',
    line: {
      color: '#ffa500',
      dash: 'solid',
      width: 2
    },
    hoverlabel: {
      ...HOVER_LABEL,
      bordercolor: '#ffa500'
    },
    hoverinfo: 'y+x+name'
  };

  let valueTrace = {
    lineType: 'line',
    key: `value-${index}`,
    x: [],
    y: [],
    visible: true,
    name: 'Selected Alternative',
    line: {
      width: 2,
      dash: 'solid',
      color: '#44c3ff'
    },
    hoverlabel: {
      ...HOVER_LABEL,
      bordercolor: '#44c3ff'
    },
    hoverinfo: 'y+x+name'
  };

  annualData.forEach((item, index) => {
    const { date, value, minimum, maximum, average, fiftieth, ninetieth, tenth } = item;
    tenthTrace.y.push(tenth);
    tenthTrace.x.push(date);

    ninetiethTrace.y.push(ninetieth);
    ninetiethTrace.x.push(date);

    averageTrace.y.push(average);
    averageTrace.x.push(date);

    fiftiethTrace.y.push(fiftieth);
    fiftiethTrace.x.push(date);

    minimumTrace.y.push(minimum);
    minimumTrace.x.push(date);

    maximumTrace.y.push(maximum);
    maximumTrace.x.push(date);

    valueTrace.y.push(value);
    valueTrace.x.push(date);
    valueTrace.name = (item.short_name || 'Selected Alternative') + ` - ${item.date.slice(0, 4)}`
  });

  return [
    tenthTrace,
    ninetiethTrace,
    minimumTrace,
    maximumTrace,
    averageTrace,
    fiftiethTrace,
    valueTrace,
  ]
};

// takes the chart data and adds the thresholds
export const buildChartData = (data, thresholds, stages, datum, useDatum) => {
  // copy the data items
  let copyData = [...data];
  if(useDatum){
    copyData = copyData.map(trace => {
      return {
        ...trace,
        y: trace.y.map(y => parseFloat(y) - parseFloat(datum)) // adjust the y values for the dayum;
      }
    });
  };
  let threshHolder = [];
  let stageHolder = [];
  // if we have thresholds, concat them onto the data
  if(thresholds && thresholds.length && copyData && copyData.length){
    thresholds.forEach((threshold, i) => {
      let { name, value, show, width, dash, color, hoverinfo, fill, key } = threshold;
      if(show && name && value){
        // if completed, concat to the data array
        threshHolder.push({
          lineType: 'threshold',
          key: key || `threshold-${i}`,
          x: copyData[0].x,
          y: copyData[0].x.map(x => {
            if(key && key.includes('stage')){
              if(useDatum){
                return parseFloat(threshold.value) - parseFloat(datum)
              } else {
                return threshold.value
              }
            } else {
              return threshold.value
            }
          }),
          hoverinfo,
          hoverlabel: {
            ...HOVER_LABEL,
          },
          fill,
          name: threshold.name,
          line: { 
            width, 
            dash, 
            color,
          },
        })
      };
    })
  };

  if(stages && stages.length && copyData && copyData.length){
    stages.forEach((stage, i) => {
      let { name, value, show, width, dash, color, hoverinfo, fill, key, showlegend } = stage;
      if(show && name && value){
        // if completed, concat to the data array
        stageHolder.push({
          lineType: 'stage',
          key: key || `stage-${i}`,
          x: copyData[0].x,
          y: copyData[0].x.map(x => {
            if(key && key.includes('stage')){
              if(useDatum){
                return parseFloat(value) - parseFloat(datum)
              } else {
                return value
              }
            } else {
              return value
            }
          }),
          hoverinfo,
          hoverlabel: {
            ...HOVER_LABEL
          },
          fill,
          showlegend,
          name: stage.name,
          line: { 
            width, 
            dash, 
            color,
          },
        })
      };
    })
  };

  // return the combined data sets
  return [...stageHolder, ...copyData, ...threshHolder];
};

// const resolvePorMaxScaleValue = (scale) => {
//   switch(scale){
//     case 'STAGE (FEET)':
//       return 10;
//     case 'FLOW (CFS)':
//       return 10000;
//     case 'ELEV-TAILWATER (FEET)':
//       return 10;
//     case 'ELEV (FEET)':
//       return 10;
//     case 'FLOW-IN (CFS)':
//       return 10000;
//     case 'FLOW-OUT (CFS)':
//       return 10000;
//     case 'ENERGY (MWh)':
//       return 1500;
//     case 'POWER (MW)':
//       return 100
//     default:
//       return 100;
//   }
// }

// const resolvePorMinScaleValue = (scale) => {
//   switch(scale){
//     case 'STAGE (FEET)':
//       return -10;
//     case 'FLOW (CFS)':
//       return -10000;
//     case 'ELEV-TAILWATER (FEET)':
//       return -10;
//     case 'ELEV (FEET)':
//       return -10;
//     case 'FLOW-IN (CFS)':
//       return -10000;
//     case 'FLOW-OUT (CFS)':
//       return -10000;
//     case 'ENERGY (MWh)':
//       return -1500;
//     case 'POWER (MW)':
//       return -100
//     default:
//       return -100;
//   }
// }

// build period of record data
export const buildPor = (data, base, comp, porDataScale) => {
  let y = []
  let zContainer = [];
  let x = DATESTRINGS;
  Object.keys(data[base]).forEach(year => {
    y.push(year);
    let r = DATESTRINGS.map((item, index) => {
      let doy = index + 1;
      // console.log(item);
      let baseValue = 0;
      let compValue = 0;
      // let baseValue = parseFloat(data[base][year][index].value);
      // let compValue = parseFloat(data[comp][year][index].value);
      let baseFind = data[base][year].find(a => a.year_dates_id === doy);
      let compFind = data[comp][year].find(h => h.year_dates_id === doy);
      if(baseFind && compFind) {
        if(baseFind.value !== "NaN"){
          baseValue = baseFind.value;
        }
        if(compFind.value !== "NaN"){
          compValue = compFind.value;
        }
      }

      return { 
        year: year, 
        day: item, 
        zAbs: compValue && baseValue ?  parseFloat(compValue - baseValue) : 0, 
        z: compValue && baseValue ?  parseFloat((compValue - baseValue) / baseValue) : 0,
        base: baseValue, 
        comp: compValue,
        baseText: base, 
        compText: comp,
        noData: !compValue && !baseValue
      };
    })
    zContainer.push(r);
  });

  let z = zContainer.map(item => {
    return item.map(({z}) => {
      return parseFloat(z)
    });
  });

  let text = zContainer.map(item => {
    return item.map(({z, year, day, baseText, compText, base, comp, noData}) => {
      return noData ? (`
        No data available for ${day}, ${year}
      `) : (`
        Date: ${day}, ${year} <br>
        ${baseText} value: ${base}<br>
        ${compText} value: ${comp}<br>
        Percentage difference: ${Math.round(parseFloat(z) * 100)}%
      `)
    });
  });

  return {
    x,
    y,
    z,
    text,
    hoverinfo: 'text',
    meta: zContainer,
    reversescale: true,
    type: 'heatmap',
    zauto: false,
    zmin: -1,
    zmax: 1,
    colorbar: {
      tickvals: [-1, -0.5, 0, 0.5, 1],
      tickmode: "array",
      ticktext:['-100%', '-50%', '0%', '50%' ,'100%'],
    },
    colorscale: [
      ['0', 'rgb(90,138,198)'],
      ['0.05', 'rgb(107,150,204)'],
      ['0.1', 'rgb(123,161,210)'],
      ['0.15', 'rgb(139,173,216)'],
      ['0.2', 'rgb(155,184,221)'],
      ['0.25', 'rgb(171,195,227)'],
      ['0.3', 'rgb(188,207,233)'],
      ['0.35', 'rgb(204,218,238)'],
      ['0.4', 'rgb(220,230,244)'],
      ['0.45', 'rgb(236,241,250)'],
      ['0.5', 'rgb(255,255,255)'],
      ['0.55', 'rgb(251,237,240)'],
      ['0.6', 'rgb(251,222,225)'],
      ['0.65', 'rgb(250,207,210)'],
      ['0.7', 'rgb(250,193,195)'],
      ['0.75', 'rgb(250,178,181)'],
      ['0.8', 'rgb(249,163,166)'],
      ['0.85', 'rgb(249,149,151)'],
      ['0.9', 'rgb(248,134,136)'],
      ['0.95', 'rgb(248,119,121)'],
      ['1.0', 'rgb(248,105,107)'],
    ]
  }
};

export const resolveLineColor = (data, alt) => {
  const match = data.find(({short_name}) => short_name === alt);
  if(match && match.line && match.line.color){
    //return it
    return match.line.color;
  } else {
    return '#eaeaea';
  }
};


// WEBPACK FOOTER //
// ./src/utilities/index.js